import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { PropertiesPage } from 'src/modules/catalog/components/pages/properties.page';
import { propertiesSearchSchema } from 'src/modules/catalog/schemas/properties-search.schema';

export const Route = createFileRoute('/catalog/properties/')({
  component: CatalogPropertiesComponent,
  validateSearch: (search) => {
    const parsed = propertiesSearchSchema.safeParse(search);
    if (parsed.success) return parsed.data;

    return propertiesSearchSchema.parse({});
  },
});

function CatalogPropertiesComponent() {
  return (
    <AuthenticateRoute>
      <PropertiesPage />
    </AuthenticateRoute>
  );
}
